export function stringifyArgs(args: unknown[], filterErrors = true) {
  const filteredArgs = filterErrors ? args.filter((arg) => !(arg instanceof Error)) : args;
  return filteredArgs
    .map((arg) => {
      if (arg instanceof Error) return arg.message;
      if (typeof arg === "string") return arg;
      try {
        return JSON.stringify(arg);
      } catch {
        try {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return (arg as any).toString();
        } catch {
          return "EXC";
        }
      }
    })
    .join(" ");
}
